const FAKED_VALIDATE_ASSISTED = {
  transactionId: "b2f681fa-2bff-4650-a73d-1a370ddeddd6"
};

const FAKED_GET_TOKEN_RESPONSE = {
  status: "OK",
  token: "Fake Token Response",
  clientIP: "127.0.0.1",
  executiveIP: "127.0.0.1",
  clientProvider: "EQUIFAX"
};

class PreviredAPIClientMock {
  submitPreviredDataRequest() {
    return new Promise(rs => rs(FAKED_VALIDATE_ASSISTED));
  }

  getPreviredToken() {
    return new Promise(rs => rs(FAKED_GET_TOKEN_RESPONSE));
  }
}

export { PreviredAPIClientMock as default };
